export enum CurrencyType {
  Usd = 'usd',
  CryptoSecondary = 'crypto_secondary',
  CryptoPrimary = 'crypto_primary',
}
